class ConversionElementsComponent {
  private elScope: HTMLElement;

  private selector: {
    ctaLeft: HTMLElement,
    ctaRights: NodeListOf<HTMLElement> | null,
    btCollapseLeft: HTMLElement,
    link: HTMLElement,
  };

  private className = {
    isCollapsed: 'is-collapsed',
    hidden: 'is-hidden'
  };

  constructor(elScope: HTMLElement) {
    this.elScope = elScope;

    this.selector = {
      ctaLeft: this.elScope.querySelector('.js-o-ce__cta-left') as HTMLElement,
      ctaRights: this.elScope.querySelectorAll('.js-o-ce__cta-right'),
      btCollapseLeft: this.elScope.querySelector('.js-o-ce__cta-left__close') as HTMLElement,
      link: this.elScope.querySelector('.o-ce__cta-left-bt') as HTMLElement,
    }
    this.init();
  }

  private init() {
    const { selector } = this;

    if (selector.link) {
      const storage = JSON.parse(window.localStorage.getItem('downloaded') || '[]');

      const foundItem = storage.filter((item: any) => item.selector == selector.link.dataset.id);
      // @ts-expect-error
      if (foundItem.length && Math.abs(new Date() - new Date(foundItem[0].date)) < 24 * 60 * 60 * 1000) {
        this.elScope.style.display = 'none';
      } else {
        const newItems = storage.filter((item: any) => item.selector != selector.link.dataset.id);
        window.localStorage.setItem('downloaded', JSON.stringify(newItems));
      }
    }

    window.addEventListener('scroll', () => {
      if (window.scrollY > 1000) {
        this.appear();
      }
    });

    if(selector.btCollapseLeft) {
      selector.btCollapseLeft.addEventListener('click', () => this.collapseLeft());
    }

    if (selector.ctaLeft) {
      document.body.classList.add('is-conversion-element-left');
    }

    if (selector.ctaRights) {
      document.body.classList.add('is-conversion-element-right');
    }

    if (selector.link) {
      // selector.link.addEventListener('click', () => {
      //   const storage = JSON.parse(window.localStorage.getItem('downloaded') || '[]');
      //   storage.push({selector: selector.link.dataset.id, date: new Date()});
      //   window.localStorage.setItem('downloaded', JSON.stringify(storage));
      // });
    }
  }

  private collapseLeft() {
    const { selector, className } = this;

    selector.ctaLeft.classList.add(className.isCollapsed);
  }

  private appear() {
    const { elScope, selector, className } = this;

    if (elScope) {
      elScope.classList.remove(className.hidden);
    }

    if (selector.ctaLeft) {
      selector.ctaLeft.classList.remove(className.hidden);
    }
    if (selector.ctaRights) {
      selector.ctaRights.forEach( (ctaRight) => {
        ctaRight.classList.remove(className.hidden);
      })
    }
  }
}
export default class ConversionElements {
  init() {
    document.querySelectorAll('.js-o-ce').forEach((el) => {
      new ConversionElementsComponent(el as HTMLElement);
    });
  }
}
